(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentsConfirmMFADetails',
	};

	$(document).ready(function documentReady()
	{
		var warning_msg = '',
		    $modal      = $('#modalWindow');

		Adzuki.Form.registerForm(form);

		if ($('#agentsconfirmmfadetails-show_warning').val() ==="1") {
			// if remind me button is present
			if ($('#remind-me-later-btn').length) {
				warning_msg = 'You must click the "Remind me Later" button or the "Confirm Details" button on this screen before proceeding to use the rest of the system.';
			// only one choice
			} else {
				warning_msg = 'You MUST submit this form before proceeding to use the rest of the system.';
			}

			Adzuki.StatusMessage('warning', warning_msg, 'Alert');
		}

		$('#remind-me-later-btn').on('click', function remindMeLater() {
			window.location.href = Adzuki.base_uri + '/Agents/confirmMFADetailsReminder';
		});

		$('#agentsconfirmmfadetails-cell_phone').on('blur', function validatePhoneNumber() {
			var val              = $(this).val(),
			    is_international = (/^\+\d{1,3} \d{3}-\d{3}-\d{4}$/).test(val), // Match +<country> xxx-xxx-xxxx (e.g. +1 555-123-4567)
			    $sms_checkbox    = $('.primary-mfa-method-checkbox[value="sms"]');

			if (is_international) {
				$sms_checkbox.prop('disabled', false);
			} else {
				$sms_checkbox.prop('disabled', true);
				$sms_checkbox.prop('checked', false).trigger('change');
			}
		});

		$('.primary-mfa-method-checkbox').on('change', function primaryMfaMethodChange() {
			setPrimaryMfaOptions();
		});

		// TOTP specific stuff
		$('#totp_checkbox').on('change', function totpCheckboxChange(e) {
			var $self       = $(this),
			    $totp_setup = $('#totp-setup');

			if (!$self.prop('checked')) {
				return;
			}

			// only if the totp-setup div is present
			if (!$totp_setup.length) {
				return;
			}

			// hidden field which indicates if the user just verified their software token in the modal
			if ($('#verified_software_token').val() === '1') {
				return;
			}

			e.preventDefault();

			$modal.find('.modal-title').html('Set up ' + $self.data('label') + ' MFA');
			$modal.find('.modal-body').html($totp_setup.html());
			$modal.find('.modal-dialog').addClass('modal-medium');

			Adzuki.Form.initAjaxForm('VerifySoftwareToken');
			$modal.modal('show');

			$self.prop('checked', false);
			setPrimaryMfaOptions();
		});

		$(document).on('click', '.show-secret-key', function showSecretKey(e) {
			e.preventDefault();
			$modal.find('#secret-code').toggleClass('hidden');
		});
		// end of TOTP specific stuff

		// get the first option HTML from a select field
		function getSelectFirstOptionHtml($select) {
			var firstOptionHtml = '';
			if ($select.length && $select.find('option').length > 0) {
				firstOptionHtml = $select.find('option').first().prop('outerHTML');
			}
			return firstOptionHtml;
		}

		// get the checked MFA methods that are not disabled
		function getSelectedMfaMethods() {
			var selectedMethods = $('.primary-mfa-method-checkbox:checked').filter(function filterDisabled() {
				return !$(this).prop('disabled');
			}).map(function checkboxChange() {
				return $(this).attr('id');
			}).get();

			return selectedMethods;
		}

		// set the options for the primary MFA method select field based on the checked MFA methods
		function setPrimaryMfaOptions() {
			var options = '',
			    i,
			    el,
				$select           = $('#primary-mfa-method-container select'),
				currentPrimaryMfa = $select.val(),
				firstOptionHtml   = getSelectFirstOptionHtml($select),
				selectedMethods   = getSelectedMfaMethods(),
				actualMfaOptions  = selectedMethods.length;

			// build the options for the select field
			options += firstOptionHtml;

			for (i = 0; i < selectedMethods.length; i++) {
				el = $('#' + selectedMethods[i]);
				options += '<option value="' + el.val() + '">' + el.data('label') + '</option>';
			}

			$select.html(options);

			// Auto-select logic: if only one MFA option (excluding placeholder), select it; if multiple, select none
			if (actualMfaOptions === 1) {
				// Only one actual MFA method selected - auto-select it
				$select.val($('#' + selectedMethods[0]).val());
			} else if (actualMfaOptions > 1) {
				// Multiple MFA methods selected - clear selection so user must choose
				$select.val('');
			} else if (currentPrimaryMfa && actualMfaOptions > 0) {
				// Fallback: set to previously selected primary MFA method if it still exists
				$select.val(currentPrimaryMfa);
			}

			$('#primary-mfa-method-container').toggleClass('hidden', selectedMethods.length === 0);
		}

		// if MFA method checked, make panel border standout. if not, remove panel border class
		function handleCheckboxPanel($checkbox) {
			$checkbox.closest('.option-panel').toggleClass('panel-primary', $checkbox.prop('checked'));
		}

		$('.primary-mfa-method-checkbox').on('change', function checkboxChange(e) {
			handleCheckboxPanel($(this));
		});

		// on page load, decide whether to apply checked class
		$('.primary-mfa-method-checkbox').each(function feach() {
			handleCheckboxPanel($(this));
		});
	});
}(jQuery, window.Adzuki || {}));
